module.exports = __webpack_public_path__ + "img/photo-28.6b84b8f1.jpg";